import { render } from "./Avatar.vue?vue&type=template&id=7a00da1d"
import script from "./Avatar.vue?vue&type=script&lang=js"
export * from "./Avatar.vue?vue&type=script&lang=js"
script.render = render

export default script